import React from "react";
import DBFetch from "../../utils/dbFetch";

const { REACT_APP_DATAVIZ_ID } = process.env;
export default function Dataviz() {
    let page = DBFetch(
        process.env.REACT_APP_API +
            "pages?parent="+REACT_APP_DATAVIZ_ID+"&_embed&filter[menu_order]=date&order=asc&per_page=20"
    );
    return (
        <>
            <h2>
                Chiffres-clés<br /><span>2020</span>
            </h2>
            <div className="dataviz__container ">
            {page?.length > 0
                ? page.map((item, index) => {
                      const { id, img_medium, acf } = item;
                      const { chiffre, chiffre_texte, descriptif } = acf;
                   
                      return (
                          <div key={id} className={`item item${index}`}>
                            <div className="item__container">
                                {img_medium && (
                                    <img
                                        className="responsive-image"
                                        src={img_medium}
                                        alt=""
                                    />
                                )}
                                <p
                                    className="chiffre"
                                    dangerouslySetInnerHTML={{
                                        __html: chiffre
                                    }}
                                />
                                
                                    <div className="chiffre_texte"
                                    dangerouslySetInnerHTML={{
                                            __html: chiffre_texte
                                        }}
                                        />
                                    <div
                                        className="descriptif"
                                        dangerouslySetInnerHTML={{
                                            __html: descriptif,
                                        }}
                                    />
                                </div>
                       
                          </div>
                      );
                  })
                : null}
            </div>
        </>
    );
}
